import React, { useEffect } from 'react'
import nbrApi from '../../../services/nbrApi'
import { useSelector } from 'react-redux'

function ForecastList() {
	const selectedLoginData = useSelector(state => state.auth.loginData)

    useEffect(() => {
        // fetch
        fetchForecastList()
    }, [])

    // fetch from API
    const fetchForecastList = async () => {
        const res = await nbrApi.post('/getforecastlist', {properties_id : selectedLoginData.properties_id })
        console.log(res.data)
    }

    // render
    return (
        <div>ForecastList</div>
    )
}

export default ForecastList